import { useAuth0 } from '@auth0/auth0-react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import LoadingSpinner from '../LoadingSpinner'

const TryNow = () => {
  const { loginWithRedirect, isAuthenticated } = useAuth0()
  const navigate = useNavigate()

  useEffect(() => {
    if (!isAuthenticated) {
      localStorage.setItem('Try', 'true')
      loginWithRedirect({ authorizationParams: { screen_hint: 'signup' } })
    } else {
      navigate(`/plans`)
    }
  }, [isAuthenticated, loginWithRedirect, navigate])

  return <LoadingSpinner />
}

export default TryNow
